import {
  PAYPAL_TX_LOOKUP_REQUEST,
  PAYPAL_TX_LOOKUP_SUCCESS,
  PAYPAL_TX_LOOKUP_ERROR,
  PAYPAL_TX_LOOKUP_RESET,
} from "./ActionType";
import { ROUTES_NAME } from "../../../config/constants";
import { ACCESS_TOKEN } from "../../../constants";

export const lookupPaypalTransaction = (payload) => {
  const { shopId, shopMerchantAccountId, transactionId } = payload;
  return (dispatch) => {
    dispatch({ type: PAYPAL_TX_LOOKUP_REQUEST });
    const url = `${process.env.REACT_APP_BACKEND_API_URL}${ROUTES_NAME.paypalTxLookup()}`;

    fetch(url, {
      method: "POST",
      body: JSON.stringify({ shopId, shopMerchantAccountId, transactionId }),
      credentials: "include",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(ACCESS_TOKEN),
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text().catch(() => "");
          throw new Error(`HTTP ${res.status}: ${text.slice(0, 200) || res.statusText}`);
        }
        return res.json();
      })
      .then((data) => dispatch({ type: PAYPAL_TX_LOOKUP_SUCCESS, payload: data }))
      .catch((err) =>
        dispatch({ type: PAYPAL_TX_LOOKUP_ERROR, payload: err?.message || "Network error" })
      );
  };
};

export const resetPaypalTransactionLookup = () => ({ type: PAYPAL_TX_LOOKUP_RESET });
